import { AUTO_PAUSE_TOLERANCE } from '../settings/defaults';
import type { PlayerAdapter } from './types';

export class AutoPauseController {
  private target: number | null = null;
  private frameId: number | null = null;

  constructor(
    private readonly player: PlayerAdapter,
    private readonly onAutoPause: () => void,
    private readonly tolerance = AUTO_PAUSE_TOLERANCE,
  ) {}

  setTarget(time: number): void {
    this.target = time;
    this.start();
  }

  getTarget(): number | null {
    return this.target;
  }

  clearTarget(): void {
    this.target = null;
    this.stop();
  }

  start(): void {
    if (this.frameId !== null) return;
    this.frameId = requestAnimationFrame(this.check);
  }

  stop(): void {
    if (this.frameId === null) return;
    cancelAnimationFrame(this.frameId);
    this.frameId = null;
  }

  dispose(): void {
    this.clearTarget();
  }

  private readonly check = (): void => {
    this.frameId = null;
    if (this.target === null) return;

    if (this.player.getCurrentTime() >= this.target - this.tolerance) {
      this.player.pause();
      this.target = null;
      this.onAutoPause();
      return;
    }
    this.frameId = requestAnimationFrame(this.check);
  };
}
